import React from "react"
import Features from "../components/features"
import Layout from "../components/layout"
import Showcase from "../components/showcase"
import { Helmet } from "react-helmet"
import config from "../lib/config"

export default function Example() {
  return (
    <Layout>
      <Helmet>
        <title>Solutions &mdash; {config.siteTitle}</title>
      </Helmet>
      <Showcase />
      <Features />
    </Layout>
  )
}
